import qs from 'query-string';

const URL_PARAMS_OPTIONS: qs.StringifyOptions = {
  arrayFormat: 'comma',
  sort: false,
  skipEmptyString: true,
  skipNull: true,
};

export function ensureStringArray(value: unknown): string[] | undefined {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }
  if (Array.isArray(value)) {
    return value
      .filter((v): v is string | number => v != null)
      .map((v) => String(v));
  }

  const stringValue = String(value);
  if (stringValue.includes(',')) {
    return stringValue
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
  }
  return [stringValue];
}

export function stringifyUrlParams(params: Record<string, unknown>): string {
  return qs.stringify(params, URL_PARAMS_OPTIONS);
}

export function parseUrlParams(
  search: string
): qs.ParsedQuery<string | number> {
  return qs.parse(search, {
    ...URL_PARAMS_OPTIONS,
    parseNumbers: true,
  });
}
